import axios from 'axios';

import {failureHandler, successHandler} from './interceptors';

const apiInstanceNoCredential = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL || 'http://localhost:3000/entrio/api',
  timeout: 30000,
});

// Add environment variable check and warning
if (!process.env.REACT_APP_API_BASE_URL) {
  console.warn(
    '⚠️ REACT_APP_API_BASE_URL is not defined. Using default: http://localhost:3000/entrio/api'
  );
}

console.log(
  '🚀 ~ apiInstanceNoCredential baseURL:',
  process.env.REACT_APP_API_BASE_URL || 'http://localhost:3000/entrio/api'
);

apiInstanceNoCredential.interceptors.response.use(successHandler, failureHandler);

export async function getWeatherByLatLon(lat: number, lon: number) {
  const res = await axios.get(`https://api.weather.gov/points/${lat},${lon}`);
  const weather = await axios.get(res.data.properties.forecast);
  return weather;
}

export default apiInstanceNoCredential;
